export default __webpack_public_path__ + "static/media/onboardingAside.bc750ed5.png";